import { LoginActions } from './LoginAction/LoginAction.ts';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Apis, Labels } from '../app.constants';
import {
  UserMinimalListAtom,
  authAtom,
  stateListAtom,
  userInformationAtom,
} from '../../Services/_states';
import SweetAlert from '../../components/Shared/Notification';
import APIService from '../../Services/APIService';
import AWS from 'aws-sdk'; // Import entire SDK (optional)
// import AWS from 'aws-sdk/global'; // Import global AWS namespace (recommended)
import S3 from 'aws-sdk/clients/s3'; // Import only the S3 client
import { useNavigate } from 'react-router';
import { globalpermissions } from '../Permission';
import { isPlatformSuperAdmin } from '../../utils/isPlatformSuperAdmin.ts';
import { resolveAuthzV2Enabled } from '../../config/authz';

const ConstantActions = () => {
  const navigate = useNavigate();
  const [userAuth, setUserAuth] = useRecoilState(authAtom);
  const [userInformation, setUserInformation] = useRecoilState(userInformationAtom);
  const setStateList = useSetRecoilState(stateListAtom);
  const setUserMinimalList = useSetRecoilState(UserMinimalListAtom);
  const loginActions = LoginActions();

  const getStateList = async () => {
    let res = await APIService.get(Apis.getStateList);
    if (res.status == 200) {
      setStateList(res.data);
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getCityByState = async (stateId) => {
    let res = await APIService.get(`${Apis.getCityList}?id=${stateId}`);
    if (res.status == 200) {
      return res.data.cities;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getAreaByCity = async (cityid) => {
    let res = await APIService.get(`${Apis.getAreaList}${cityid}/?type=areas`);
    if (res.status == 200) {
      return res.data;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getOrganisations = async () => {
    let res = await APIService.get(`${Apis.getOrganisationsList}`);
    if (res.status == 200) {
      return res?.data || [];
    } else {
      SweetAlert(Labels.Error, 'error');
    }
    // }
  };

  const getOrganisationsWithPagination = async (data) => {
    try {
      let url = `${Apis.Get_Organisation_List}?next_page=${data?.page || 1}&search=${data?.search}`;
      if (data?.category) {
        url += `&catgory=${data?.category}`;
      }
      if (data?.limit) {
        url += `&limit=${data?.limit}`;
      }
      let res = await APIService.get(url);
      return res;
    } catch (error) {
      SweetAlert(Labels.Error, 'error');
    }
    // }
  };

  const getUserMinimalList = async (orgId, filters = {}) => {
    let res = await APIService.get(
      `${Apis.getUserMinimalList}?org_id=${orgId}&campaign_id=${filters?.campaign_id ?? ''}`
    );
    if (res.status == 200) {
      setUserMinimalList(res?.data);
      return res.data;
    } else {
      setUserMinimalList([]);
      SweetAlert(Labels.Error, 'error');
    }
  };
  const getMachadaloStatusList = async ({
    dashboard = 'macahdalo',
    campaignId = '',
    category = '',
  }) => {
    let res = await APIService.get(
      `${Apis.getMachadaloStatusList}?dashboard=${dashboard}&campaign_id=${campaignId || ''}&category=${category}`
    );
    if (res.status == 200) {
      return res?.data;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const getKeyStakeholdersByOrganisation = async (organisationId) => {
    try {
      let res = await APIService.get(`${Apis.getRoleByOrganisation}${organisationId}`);
      if (res.status === 200) {
        return res?.data || [];
      } else {
        SweetAlert(Labels.Error, 'error');
        return [];
      }
    } catch (error) {
      console.error('Error fetching key stakeholders:', error);
      SweetAlert(Labels.Error, 'error');
      return [];
    }
  };

  const getUsersByOrganisation = async (data) => {
    try {
      let res = await APIService.get(
        `${Apis.getUsersByOrganisation}?organisation_id=${data?.organisationId}&next_page=${data?.page || 1}&search=${data?.search || ''}`
      );
      if (res.status === 200) {
        return res?.data || [];
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };

  const postFacebookData = async (data) => {
    try {
      let res = await APIService.post('v0/ui/whatsapp-v2/get-access-token/', data);
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  // v0/ui/bot-builder/flow/list/
  const uploadFileS3Bucket = async (formData) => {
    try {
      const response = await APIService.uploadFile(Apis?.uploadFileS3Bucket, formData, null);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  // const uploadFileS3Bucket = async (file, bucketName = 'mdimages') => {
  //   const S3_BUCKET = bucketName; // Replace with your bucket name
  //   const REGION = 'us-east-1'; // Replace with your region

  //   AWS.config.update({
  //     accessKeyId: process.env.REACT_APP_AWS_ACCESS_ID,
  //     secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  //   });
  //   const s3 = new S3({
  //     params: { Bucket: S3_BUCKET },
  //     region: REGION,
  //   });

  //   const params = {
  //     Bucket: S3_BUCKET,
  //     Key: file.name,
  //     ContentType: file.type,
  //     Body: file,
  //   };
  //   try {
  //     const upload = await s3.putObject(params).promise();
  //     return upload;
  //     // setUploading(false)
  //     // alert("File uploaded successfully.");
  //   } catch (error) {
  //     console.error(error);
  //     // setUploading(false)
  //     // alert("Error uploading file: " + error.message); // Inform user about the error
  //   }
  // };

  const userHasPermission = (permissions) => {
    if (!userAuth?.token) {
      return false;
    }
    if (userInformation?.is_superuser === true || isPlatformSuperAdmin(userInformation)) {
      return true;
    }

    if (resolveAuthzV2Enabled(userInformation)) {
      const featureGrants = userInformation?.profile?.rbac_grants?.features || {};
      const objectGrants = userInformation?.profile?.rbac_grants?.objects || {};
      for (let i = 0; i < permissions.length; i += 1) {
        const codename = permissions[i];
        if (featureGrants[codename]) {
          return true;
        }
        if (userInformation?.profile?.permissions?.[codename] === true) {
          return true;
        }
        if (
          codename === 'can_view_self_service_form' &&
          (objectGrants?.dataset?.can_view || objectGrants?.datasetrecord?.can_view)
        ) {
          return true;
        }
        if (
          codename === 'can_view_self_service_data' &&
          (objectGrants?.datasetrecord?.can_view || objectGrants?.dataset?.can_view)
        ) {
          return true;
        }
        if (codename === 'can_create_dataset' && objectGrants?.dataset?.can_create) {
          return true;
        }
        if (codename === 'can_edit_dataset' && objectGrants?.dataset?.can_update) {
          return true;
        }
      }
      return false;
    }

    for (let i = 0; i < permissions.length; i += 1) {
      if (userInformation?.profile?.permissions?.hasOwnProperty(permissions[i])) {
        if (userInformation?.profile.permissions[permissions[i]] === true) return true;
      }
    }
    return false;
  };

  const postSmsList = async (data) => {
    try {
      let res = await APIService.post(Apis.postSmsList, data);
      if (res.status === 200) {
        return res?.data || [];
      } else {
        SweetAlert(Labels.Error, 'error');
        return [];
      }
    } catch (error) {
      console.error('Error posting SMS list:', error);
      SweetAlert(Labels.Error, 'error');
      return [];
    }
  };

  const sendTemplate = async (data) => {
    try {
      let res = await APIService.get(Apis.sendTemplate, data);
      if (res.status === 200) {
        return res?.data || [];
      } else {
        SweetAlert(Labels.Error, 'error');
        return [];
      }
    } catch (error) {
      console.error('Error sending template:', error);
      SweetAlert(Labels.Error, 'error');
      return [];
    }
  };

  const getAccounts = async ({ organisation_id }) => {
    if (!organisation_id) {
      console.warn('Missing organisation_id in getAccounts');
      return { status: 400, data: [] }; // ✅ fix
    }

    try {
      const res = await APIService.get(
        `${Apis.getAccountsList}?organisation_id=${organisation_id}`
      );
      return res;
    } catch (error) {
      console.error("API Error:", error.response?.data);
      return error.response; // ✅ important
    }
  };

  const logout = () => {
    localStorage.clear();
    setUserAuth({});
    setUserInformation({});
    navigate('/r/login');
    window.location.reload();
  };

  // const getDynamicHomePageLink = () => {
  //   if (userHasPermission([globalpermissions?.pagePermissions?.homePage])) {
  //     return '/r/management/manageCampaign/';
  //   } else if (userHasPermission([globalpermissions?.pagePermissions?.campaignLeadsPageAccess])) {
  //     return '/r/leads/v1';
  //   } else if (userHasPermission([globalpermissions?.pagePermissions?.templateDashboardNew])) {
  //     return '/r/v2/whatsapp-templates/template-list';
  //   } else return '/r/management/managecampaign';
  // };
  const getDynamicHomePageLink = () => {
    return '/r/dashboards';
  };


  const refreshUserProfile = async () => {
    try {
      const userId = userInformation?.id;
      if (!userId) return;

      const res = await loginActions.userInformation(userId);

      if (res?.status === 200 && res?.data) {
        const userData = res.data;

        if (userData.profile) {
          const permissions = {};
          (userData.profile.general_user_permission || []).forEach((perm) => {
            permissions[perm.name.toLowerCase()] = perm.is_allowed;
          });
          userData.profile.permissions = permissions;
        }

        setUserInformation(userData);
        localStorage.setItem('userInfo', JSON.stringify(userData));
        return userData;
      }
    } catch (error) {
      console.error('Error refreshing user profile:', error);
    }
  };

  return {
    getStateList,
    getCityByState,
    getAreaByCity,
    getOrganisations,
    getUserMinimalList,
    getMachadaloStatusList,
    uploadFileS3Bucket,
    userHasPermission,
    getKeyStakeholdersByOrganisation,
    getUsersByOrganisation,
    postFacebookData,
    getOrganisationsWithPagination,
    postSmsList,
    sendTemplate,
    getAccounts,
    logout,
    getDynamicHomePageLink,
    refreshUserProfile,
  };
};

export { ConstantActions };
